/**
 * Add measureIds and incidentIds to simulations
 */

export default {
  applyToVersions: "<2.2.0",
  type: "before",
  name: "add measureIds and incidentIds to simulations",
  migrate(data) {
    if (!data || !data?.games) return data;

    const simulations = data.games?.items ?? {};
    for (const simulationId in simulations) {
      const simulation = simulations[simulationId];
      if (simulation.scenarioId == null) continue;

      const scenario = data.scenarios.items[simulation.scenarioId];

      if (!simulation.measureIds) {
        simulation.measureIds = (scenario?.measureIds ?? []).slice(0);
      }
      if (!simulation.incidentIds) {
        simulation.incidentIds = (scenario?.incidentIds ?? []).slice(0);
      }
    }

    return data;
  }
};
